var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3177_873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3177_873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.667 0.5H0.666992V46.5H50.667V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3177_873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5003 13.9024C28.3394 13.8421 28.1643 13.914 28.0829 14.0652L12.3649 43.2569C12.2249 43.5169 12.4501 43.8228 12.74 43.7663L45.6509 37.3582C45.8242 37.3245 45.9456 37.167 45.9307 36.9911C45.0227 26.2713 34.9672 16.3263 28.5003 13.9024Z",
    fill: "#FFA00B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8384 5.1237L7.59228 40.3792L43.6967 28.1403C42.058 22.4788 38.2358 17.2502 33.7129 13.105C29.3609 9.11643 24.5628 6.31553 20.8384 5.1237ZM17.5626 2.25374C17.9587 1.1996 19.0884 0.486518 20.312 0.759022C25.0811 1.82115 31.197 5.27047 36.4668 10.1002C41.7532 14.9451 46.4473 21.4155 48.0488 28.7254C48.313 29.9312 47.6173 31.115 46.4795 31.5007L5.53848 45.3791C3.62476 46.0278 1.81743 44.1606 2.52814 42.269L17.5626 2.25374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3625 18.7539C21.3625 21.2031 19.377 23.1886 16.9278 23.1886C14.4787 23.1886 12.4932 21.2031 12.4932 18.7539C12.4932 16.3048 14.4787 14.3193 16.9278 14.3193C19.377 14.3193 21.3625 16.3048 21.3625 18.7539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2201 25.9604C38.2201 28.1238 36.4663 29.8775 34.3029 29.8775C32.1395 29.8775 30.3857 28.1238 30.3857 25.9604C30.3857 23.797 32.1395 22.0432 34.3029 22.0432C36.4663 22.0432 38.2201 23.797 38.2201 25.9604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4985 30.9023C22.4985 32.4354 21.2556 33.6783 19.7224 33.6783C18.1892 33.6783 16.9463 32.4354 16.9463 30.9023C16.9463 29.3691 18.1892 28.1262 19.7224 28.1262C21.2556 28.1262 22.4985 29.3691 22.4985 30.9023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4872 37.8092C16.7406 38.8201 15.7404 39.9418 14.2532 40.3145C12.7661 40.6873 11.3551 40.1699 11.1017 39.159C10.8483 38.1481 11.8485 37.0264 13.3357 36.6537C14.8229 36.2809 16.2338 36.7983 16.4872 37.8092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8479 7.42353C17.2554 6.37439 18.4364 5.85432 19.4855 6.26192C24.1985 8.09294 36.6977 14.2891 43.066 30.1426C43.4855 31.187 42.979 32.3738 41.9346 32.7933C40.8902 33.2129 39.7034 32.7063 39.2838 31.6619C33.5042 17.2738 22.1837 11.6828 18.0095 10.0612C16.9603 9.65357 16.4403 8.47266 16.8479 7.42353Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3177_873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 46,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/cheese.05dddfc9193198457eaa5ccbec338a18.svg";
export { ForwardRef as ReactComponent };